import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MultiShipmentExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { EntryCardChip, EntryCardRow } from '../entry-card-preview/entry-card-preview.component';
import {
  itemsStillToAssign,
  MULTI_SHIPMENT_PREVIEW,
  PREVIEW_MAX_ENTRIES,
  recipientItemChips,
  resolveAddCard,
} from '../../multi-shipment-example.model';

interface RecipientCardView {
  number: number;
  title: string;
  chips: EntryCardChip[];
  rows: EntryCardRow[];
}

@Component({
  selector: 'multi-shipment-recipient-list-preview',
  templateUrl: './recipient-list-preview.component.html',
  styleUrls: ['./recipient-list-preview.component.scss'],
  standalone: false,
})
export class RecipientListPreviewComponent implements OnChanges {
  @Input() recipientsBlock: MultiShipmentExtension.RecipientsBlock;
  @Input() recipientCount = 0;
  @Input() isMobile = false;

  @Output() recipientAdded = new EventEmitter<void>();
  @Output() recipientRemoved = new EventEmitter<void>();

  recipients: RecipientCardView[] = [];
  addCard: MultiShipmentExtension.ActionCard;
  canAddRecipient = false;
  itemsToAssign = 0;
  unassignedWarningTone: MultiShipmentExtension.TextTone = 'none';

  ngOnChanges(): void {
    const visibleRecipients = MULTI_SHIPMENT_PREVIEW.recipients.slice(0, this.recipientCount);

    this.recipients = visibleRecipients.map((recipient) => ({
      number: recipient.number,
      title: recipient.name,
      chips: recipientItemChips(recipient),
      rows: [
        { label: 'Ship to', value: recipient.address },
        { label: 'Delivery', value: recipient.deliveryDate },
        { label: 'Gift note', value: recipient.giftNote },
      ],
    }));

    this.itemsToAssign = itemsStillToAssign(visibleRecipients);
    this.unassignedWarningTone = this.recipientsBlock?.unassignedItemsWarningTone ?? 'none';
    this.canAddRecipient = this.recipientCount < PREVIEW_MAX_ENTRIES;
    this.addCard = resolveAddCard(
      this.recipientsBlock?.addRecipientCard,
      this.recipientsBlock?.addAnotherRecipientCard,
      this.recipientCount,
    );
  }
}
